import { render } from "./QimenPredict.vue?vue&type=template&id=69568963&scoped=true"
import script from "./QimenPredict.vue?vue&type=script&lang=js"
export * from "./QimenPredict.vue?vue&type=script&lang=js"

import "./QimenPredict.vue?vue&type=style&index=0&id=69568963&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69568963"]])

export default __exports__